import React from "react";

function PaginationDots() {
 return <li className="pagination__dots">&#8230;</li>;
}

export default PaginationDots;
